import script from "./THeaderVoucher.vue?vue&type=script&lang=ts&setup=true"
export * from "./THeaderVoucher.vue?vue&type=script&lang=ts&setup=true"

import "./THeaderVoucher.vue?vue&type=style&index=0&id=69ceed32&lang=scss"

const __exports__ = script;

export default __exports__